export default __webpack_public_path__ + "images/calculations.svg?bf980d628cd31ac9a548ce428df43196";